import { render } from "./AppFooter.vue?vue&type=template&id=4492528e&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=4492528e&scoped=true&lang=scss"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4492528e"]])

export default __exports__